import React, { useState, useEffect } from 'react';
import { Sun, Moon, CloudMoon } from 'lucide-react';

const ThemeSwitcher = () => {
  const [theme, setTheme] = useState('dim');

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'dim';
    setTheme(savedTheme);
    applyTheme(savedTheme);
  }, []);

  const applyTheme = (newTheme) => {
    const root = document.documentElement;
    root.classList.remove('light', 'dark', 'dim');
    root.classList.add(newTheme);
    
    if (newTheme === 'light') {
      root.style.colorScheme = 'light';
    } else {
      root.style.colorScheme = 'dark';
    }
  };

  const cycleTheme = () => {
    const themes = ['dim', 'dark', 'light'];
    const currentIndex = themes.indexOf(theme);
    const nextIndex = (currentIndex + 1) % themes.length;
    const newTheme = themes[nextIndex];
    
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    applyTheme(newTheme);
    window.dispatchEvent(new CustomEvent('themechange', { detail: newTheme }));
  };

  const getIcon = () => {
    switch (theme) {
      case 'light':
        return <Sun className="w-5 h-5" />;
      case 'dark':
        return <Moon className="w-5 h-5" />;
      case 'dim':
      default:
        return <CloudMoon className="w-5 h-5" />;
    }
  };

  const getLabel = () => {
    switch (theme) {
      case 'light':
        return 'Light';
      case 'dark':
        return 'Dark';
      case 'dim':
      default:
        return 'Dim';
    }
  };

  return (
    <button
      onClick={cycleTheme}
      data-testid="theme-switcher"
      className="flex items-center gap-2 px-4 py-2 rounded-full glass-card hover:bg-white/10 transition-all duration-300"
      aria-label={`Current theme: ${getLabel()}. Click to switch theme.`}
    >
      {getIcon()}
      <span className="text-sm font-medium hidden sm:inline">{getLabel()}</span>
    </button>
  );
};

export default ThemeSwitcher;
